var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMccTrains(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Trains",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8400",
    "data-name": "Rectangle 8400",
    width: 28,
    height: 28,
    fill: "none"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_35906",
    "data-name": "Path 35906",
    d: "M20.93,26.49H23.3L20.14,21.881h-2.4l1.042,1.506H9.218l1.041-1.506h-2.4L4.7,26.49H7.071L8,25.136h11.99Z",
    fill: "#b3b5c4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_35262",
    "data-name": "Group 35262"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_35261",
    "data-name": "Group 35261",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_35907",
    "data-name": "Path 35907",
    d: "M21.725,8.845A7.537,7.537,0,0,0,14,1.513,7.537,7.537,0,0,0,6.269,8.845c0,.143.014.282.022.423a3.688,3.688,0,0,0-.022.379V18A2.572,2.572,0,0,0,9.02,20.341h9.951A2.572,2.572,0,0,0,21.722,18V9.647a3.688,3.688,0,0,0-.022-.379c.008-.14.022-.28.022-.423ZM9.964,17.229a1.228,1.228,0,1,1,1.192-1.192,1.227,1.227,0,0,1-1.192,1.192m3.223-6.573H9.23A.757.757,0,0,1,8.473,9.9V7.665a.757.757,0,0,1,.757-.757h3.957ZM19.261,16a1.266,1.266,0,0,1-1.227,1.227A1.228,1.228,0,1,1,19.261,16Zm.264-6.1a.757.757,0,0,1-.757.757H14.776V6.908h3.992a.757.757,0,0,1,.757.757Z",
    fill: "#b3b5c4"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMccTrains);
export default __webpack_public_path__ + "static/media/mcc_trains.b316ca88cb5a18c9ba210c559360fcfa.svg";
export { ForwardRef as ReactComponent };